import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-brand-sage text-white py-24 px-6" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <div className="w-24 h-24 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-108">
          <ShieldCheck className="w-12 h-12" data-id="element-109" />
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif mb-6" data-id="element-110">
          Probalo durante 30 días.
        </h2>

        <p className="text-xl md:text-2xl text-white/90 mb-8" data-id="element-111">
          Si no sentís más claridad, menos estrés y más seguridad:
        </p>

        <div className="inline-block bg-white text-brand-sage font-bold text-2xl md:text-3xl px-8 py-4 rounded-full shadow-xl mb-6" data-id="element-112">
          👉 te devolvemos el dinero
        </div>

        <p className="text-xl font-medium opacity-80" data-id="element-113">Sin preguntas.</p>
      </div>
    </section>;
}